import DirectionData from "@/models/DirectionData";
import LineTypeData from "@/models/LineTypeData";
import WardData from "@/models/WardData";
import moment from 'moment'

var table = {
  name: "realestate.client_needs",
  list_views: {
    filters: [],
    sorts: {},
    columns: [
      "created_at",
      "needs_group",
      "needs_structure",
      "needs_direction",
      "needs_area_range",
      "needs_price_range",
      "needs_price_rent_range",
      "needs_line_type",
      "needs_population_area",
      "needs_ward",
      "needs_other",
    ],
  },
  input_view: {
    forms: [
      {
        col: "created_at",
        type: "date",
        value: new Date(),
        defaultValue: moment().format("yyyy-MM-DD"), // default value
        required: false,
        visible: true, // this is generated automatically, we don't need to show to user
        colspan: 4,
      },
      {
        col: "needs_group",
        type: "multi-select",
        value: "",
        defaultValue: "", // default value
        required: false,
        visible: true, // this is generated automatically, we don't need to show to user
        colspan: 4,
      },
      {
        col: "needs_structure",
        type: "multi-select",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
      {
        col: "needs_direction",
        type: "multi-select",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
      {
        col: "needs_area_range",
        type: "multi-select",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
      {
        col: "needs_price_range",
        type: "multi-select",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
      {
        col: "needs_price_rent_range",
        type: "multi-select",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
      {
        col: "needs_line_type",
        type: "multi-select",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
      {
        col: "needs_population_area",
        type: "multi-select",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
      {
        col: "needs_ward",
        type: "multi-select",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
      {
        col: "needs_other",
        type: "text",
        value: null,
        required: false,
        visible: true,
        colspan: 4,
      },
    ],
  },
  columns: {
    id: {
      name: "id",
      type: "Id",
      alias: "ID",
    },
    created_at: {
      name: "created_at",
      type: "date",
      alias: "Ngày giao dịch",
    },
    needs_group: {
      name: "needs_group",
      type: "text",
      alias: "Nhóm",
      options: [
        "đầu tư lướt sóng",
        "đầu tư trung dài hạn",
        "ng mua sử dụng",
        "kh ký gởi-bán",
        "kh ký gời-cho thuê",
        "kh tìm thuê",
        "Công việc - MQH",
        "Môi giới - CTV",
      ],
    },
    needs_structure: {
      name: "needs_structure",
      type: "text",
      alias: "Kết cấu BĐS",
      options: [
        "đất thổ cư",
        "đất CLN",
        "đất Lúa",
        "đất khác",
        "Nhà khác",
        "Nhà cấp 4",
        "1 trệt 1 lầu",
        "1 trệt 2 lầu",
        "1 trệt 3 lầu",
        "Nhà trên 3 lầu",
        "Biệt thự",
        "Chung cư",
        "Nhà mới xây",
        "Nhà cũ",
        "Nhà kho",
        "Nhà trọ",
        "Nhà thô",
      ],
    },
    needs_direction: {
      name: "needs_direction",
      type: "text",
      alias: "Hướng",
      options: DirectionData.data,
    },
    needs_area_range: {
      name: "needs_area_range",
      type: "text",
      alias: "Tầm diện tích",
      options: [
        "dưới 45m2",
        "45-80m2",
        "80-100m2",
        "100-200m2",
        "200-1000m2",
        "trên 1000m2",
      ],
    },
    needs_price_range: {
      name: "needs_price_range",
      type: "text",
      alias: "Khoảng giá mua",
      options: [
        "dưới 700 tr",
        "700-1000",
        "1000-1500",
        "1500-2000",
        "2000-2600",
        "2600-3700",
        "3700-5000",
        "trên 5 tỷ",
      ],
    },
    needs_price_rent_range: {
      'name': 'needs_price_rent_range',
      'type': 'text',
      'alias': 'Khoảng giá thuê',
      options: [
          'Dưới 5tr',
          '5tr - 10tr',
          '10tr - 30tr',
          'Trên 30tr'
      ]
  },
    needs_line_type: {
      name: "needs_line_type",
      type: "text",
      alias: "Loại đường",
      options: LineTypeData.data,
    },
    needs_population_area: {
      name: "needs_population_area",
      type: "text",
      alias: "Khu dân cư",
      options: [
        "Golden City",
        "Golden City GD2",
        "NOXH Golden City",
        "Bắc HHH",
        "Tây Khánh 8",
        "Lý Thái Tổ",
        "Nam Kinh",
        "Kênh đào nối dài",
        "Tây Đại Học",
        "Tây Đại Học GD2",
        "Khu AB - Tỉnh đoàn - Nam TB",
        "Khu B4 - Thiên Lộc",
        "Phú Quý",
        "Xẻo Trôm",
        "Xẻo Trôm 3",
        "Tây Sông Hậu",
        "Tây Sông Hậu GD2",
        "Lê Chân",
        "VPMQ",
        "Làng Giáo Viên",
        "Làng Giáo Viên 2",
        "Phú Cường",
        'Khu Chợ Cái Sao',
        'An Châu Central',
        'Khu Chợ Cần Đăng'
      ],
    },
    needs_ward: {
      name: "needs_ward",
      type: "text",
      alias: "Phường",
      options: WardData.data,
    },
    needs_other: {
      name: "needs_other",
      type: "text",
      alias: "Nhu cầu cụ thể",
    },
  },
  fields: [
    { key: "created_at", label: "Ngày" },
    { key: "needs_group", label: "Nhóm" },
    { key: "needs_structure", label: "Kết cấu BĐS" },
    { key: "needs_direction", label: "Hướng" },
    { key: "needs_area_range", label: "Tầm diện tích" },
    { key: "needs_price_range", label: "Khoảng giá mua" },
    { key: "needs_price_rent_range", label: "Khoảng giá thuê" },
    { key: "needs_line_type", label: "Loại đường" },
    { key: "needs_population_area", label: "Khu dân cư" },
    { key: "needs_ward", label: "Phường" },
    { key: "needs_other", label: "Nhu cầu cụ thể" },
  ],
};

export default {
  table_name: table.name,
  list_views: table.list_views,
  input_view: table.input_view,
  columns: table.columns,
  fields: table.fields,
};
